import { ErrorInfo, ErrorCode } from "@/network/http";
import { requestData } from "./base";
import { PageReq, BaseReq, BaseRsp, GetInfoByIdReq } from "@/data/remote/base";
import { nullPageInfo } from "@/data/local/base";
import { 
    GetVerifyCodeReq, 
    GetVerifyCodeRsp,
    GetFundAccountReq,
    GetFundAccountRsp
} from '@/data/remote/account'
import { VerifyCodeInfo, FundAccountInfo } from '@/data/local/account'

const URL_GET_VERIFY_CODE = "/wxyj/fund/account/getVerifyCode";// 获取验证码
const URL_GET_FUND_ACCOUNT = "/wxyj/fund/account/getFundAccount";//获取账户信息

export const getVerifyCode = (type: number, callback?: (errorInfo: ErrorInfo, data: VerifyCodeInfo | null) => void) => {
    const payload: GetVerifyCodeReq = {
        type
    };

    requestData(URL_GET_VERIFY_CODE, payload, (errorInfo: ErrorInfo, data: GetVerifyCodeRsp) => {
        let rspData: VerifyCodeInfo | null = (errorInfo.errorCode === ErrorCode.SUCCESS) ? {...data} : null;
        callback && callback(errorInfo, rspData);
    });
}

export const getFundAccount = (type: number, accountType: number, certId: string, account: string, verifyCode: string, sid: string, callback?: (errorInfo: ErrorInfo, data: FundAccountInfo | null) => void) => {
    const payload: GetFundAccountReq = {
        type,
        accountType,
        certId,
        account,
        verifyCode,
        sid
    };

    requestData(URL_GET_FUND_ACCOUNT, payload, (errorInfo: ErrorInfo, data: GetFundAccountRsp) => {
        let rspData: FundAccountInfo | null = (errorInfo.errorCode === ErrorCode.SUCCESS) ? {...data} : null;
        callback && callback(errorInfo, rspData);
    });
}